// src/utils/totems.js
// Créatures "totem" (cosmétique de profil, réservé aux soutiens à terme).
// Les SVG sont servis depuis Supabase Storage (bucket public "totems"),
// donc jamais committés dans le repo.

// name = libellé ; trait = petite caractéristique (inventée, symbolisme courant).
// name = libellé ; trait = petite caractéristique (inventée, symbolisme courant).
export const TOTEMS = [
    { key: "etoile", name: "Étoile de mer", trait: "Renouveau" },
    { key: "ecrevisse", name: "Langouste", trait: "Ténacité" },
    { key: "tortue", name: "Tortue", trait: "Sagesse" },
    { key: "raie", name: "Raie", trait: "Grâce" },
    { key: "hippocampe", name: "Hippocampe", trait: "Patience" },
    { key: "dauphin", name: "Dauphin", trait: "Joie" },
    { key: "orque", name: "Orque", trait: "Force" },
    { key: "lobster_bleu", name: "Homard bleu", trait: "Persévérance" },
    { key: "coquillage", name: "Coquillage", trait: "Calme" },
];

const KEYS = new Set(TOTEMS.map((t) => t.key));

// URL publique du SVG d'un totem (ou null si clé inconnue / vide).
export function totemUrl(key) {
    if (!key || !KEYS.has(key)) return null;
    const base = process.env.REACT_APP_SUPABASE_URL || "";
    return `${base}/storage/v1/object/public/totems/${key}.svg`;
}
